export default {
  halfWidth: {
    width: '50%',
    display: 'inline-block'
  },
  leftSide: {
    width: '50%',
    display: 'inline-block',
    paddingRight: '1rem'
  },
  container: {
    paddingBottom: '.8rem',
    position: 'relative'
  },
  cannotUse: {
    position: 'absolute',
    top: -8,
    left: -8,
    height: 'calc(100% + 8px)',
    width: 'calc(100% + 16px)',
    textAlign: 'center',
    background: 'rgba(50, 50, 50, .3)',
    zIndex: '1',
    fontSize: '2rem',
    fontWeight: 'bold',
    color: 'white',
    paddingTop: '14rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/style.js